<template>
  <!-- :el-loading="loading"
    element-loading-text="拼命加载中..."
    element-loading-background="rgba(122, 122, 122, 0.8)" 
  -->
  <div
    v-loading="loading"
    element-loading-text="加载中..."
    element-loading-background="rgba(0, 0, 0, 0)"
    class="Bar1Charts"
    ref="loading-box"
    @mousedown="!isEditMode && isOpenLink && echartClick($event)"
    :class="[{ link: isOpenLink && !isEditMode }, getStyle('title')]"
  >
    <DateDropDownSelect
      v-if="value.isShowRightDropDownBox"
      :selectData="selectData"
      :selectApi="selectApi"
      @selectChange="selectChange"
    >
    </DateDropDownSelect>
    <TableDateDownSelect
      v-if="tvalue.isShowRightDatePicker"
      :tabselectData="tabselectData"
      :pickerType="pickerType"
      :selectApi="selectApi"
      @tabSelectChange="tabSelectChange"
    >
    </TableDateDownSelect>
    <div class="echarts" :id="Configuration.id" style="z-index: 1" @mousedown="handleEchartsTap"></div>
    <div class="no-data" v-if="noData">
      <sapn>暂无数据！</sapn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { jumpSomePlaceByLink, getFilterValue } from '../../../../utils/tool';
import * as Echarts from 'echarts';
import { chartsStyle } from '../../../../mixin/index';
import DateDropDownSelect from '@/components/common/DateDropDownSelect/DateDropDownSelect.vue';
// import DatePickerSelector from '../../../common/DatePickerSelector/DatePickerSelector.vue';
import TableDateDownSelect from '@/components/common/TableDateDownSelect/TableDateDownSelect.vue';
import axios from 'axios';
import { request } from '../../../../common/request';
export default {
  name: 'Bar1Charts',
  components: { DateDropDownSelect, TableDateDownSelect },
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  mixins: [chartsStyle],
  data() {
    return {
      echartsOptions: {},
      echartsClickData: '',
      echartsClick: '',
      DataProcessing: null,
      echartsData: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      value: {
        isShowRightDropDownBox: false,
      },

      tvalue: {
        isShowRightDatePicker: false,
      },

      tabselectData: [], // 下拉选择的时间数据d
      selectApi: '',
      currentChartsList: null,
      selectData: [], // 下拉选择的时间数据
      params: {}, // 请求参数
      paramsCopy: {},
      noData: false, // 无数据
      loading: true,
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });

    // this.getApiDataResByFilterAndResponseQuery();
    this.LocalChartDataProcessing();
    this.setStyle();
    // if (this.Configuration.propertyData?.chartsRightDatePicker?.value) {
    //   this.selectValue = this.Configuration.propertyData.chartsRightDatePicker.value;
    // }
    // 默认取api参数
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    // 判断 数据 为本地或动态
    this.selectApi = ChartsData;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    console.log(this.params, 'aaaaaaaaa');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
    ...mapState({
      isEditMode: state => state.isEditMode,
    }),
    isOpenLink() {
      return this.Configuration.propertyData?.chartLink?.value?.isOpenLink;
    },
  },

  methods: {
    echartClick(e) {
      e.stopPropagation();
      console.log('点击');
      let type = this.Configuration.propertyData.chartLink.value.linkType;
      let url = this.Configuration.propertyData.chartLink.value.linkUrl;
      jumpSomePlaceByLink(type, url);
      console.log('执行后');
    },
    handleChange(val) {
      console.log(val, 'valvalval');
      /* 更新数据 */
      this.$store.commit('update_PropertyData', {
        key: 'ChartsData',
        value: val,
      });
      // console.log('api 配置数据更新')
    },
    /**新增功能start */
    selectChange(e) {
      console.log('改变 timeKey', e);
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用静态数据
      if (ChartsData?.currenEntry === 'staticData') {
        this.echartsClick = e;
        this.asyncLocalDatatest();
      } else {
        if (/[A-Za-z]+$/.test(e)) {
          this.params = this.getFilterValue(e);
          // 切换下拉值 赋值 kind
          if (this.params == 'month') {
            this.params = { kind: 'month' };
          }
        } else if (/^[\u4e00-\u9fa5]+$/.test(e)) {
          this.params = { param: e };
        } else {
          this.params = { data: e };
        }
        this.params = this.getFilterValue(e);
        this.startApiIntervalTask();
      }
    },
    tabSelectChange(e) {
      // 判断是否使用静态数据
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      if (ChartsData?.currenEntry === 'staticData') {
        this.echartsClick = e;
      } else {
        this.params = this.getFilterValue(e);
        this.startApiIntervalTask();
      }
    },
    selectDateChange(e) {
      Object.keys(this.params).forEach((key, index) => {
        this.params[key] = e[index];
      });
      this.startApiIntervalTask();
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    getParams(date) {
      let params = {};
      if (Object.keys(this.paramsCopy).length != 0) {
        Object.keys(this.paramsCopy).forEach(key => {
          params[key] = '';
        });
        Object.keys(params).forEach(key => {
          if (key.indexOf('start') != -1 || key.indexOf('Start') != -1) {
            params[key] = date + '-01';
          } else {
            if (date.indexOf('-') == -1) {
              // 年
              params[key] = date + '-12';
            } else {
              params[key] = date + '-' + getFullDayOfOneMonth(date);
            }
          }
        });
      }

      function getFullDayOfOneMonth(date) {
        let arr = date.split('-');
        return new Date(arr[0], arr[1], 0).getDate();
      }

      return params;
    },
    getSourceYearAndMonth(source, flag, param = 'x', index = 1, splitChar = '-') {
      console.log('falg', flag, 'params:', param, 'index', index);
      let result = '';
      if (flag == 'year') {
        // 形如2020-01-02
        if (source[0][param].indexOf(splitChar) != -1) {
          // 最后加上slice是为了防止有形如2020年-1月-1日的数据
          result = source[0][param].split(splitChar)[index].slice(0, 4);
        } else {
          // 形如2020年
          result = source[0][param].slice(0, 4);
        }
      } else if (flag == 'month') {
        result = source[0][param].split(splitChar)[index];
      }
      return result;
    },
    /**新增功能end */
    // 根据不同的风格取不同的颜色
    setStyle() {
      let color;
      switch (this.style) {
        case 'V1Style':
          color = '#eee';
          break;
        case 'V2Style':
          color = '#eee';
          break;
        case 'V3Style':
          color = '#fff';
          break;
        case 'V4Style':
          color = '#b044f8';
          break;
        case 'V5Style':
          color = '#09af60';
          break;
        default:
          color = '#eee';
          break;
      }
      this.$refs['loading-box'].style.setProperty('--color', color); // 给变量赋值
    },
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          style = {};
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V10Style':
          style = {};
          if (bool) style['V10StyleTitle'] = true;
          style['V10Style'] = true;
          break;
        case 'V11Style':
          style = {};
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        case 'V12Style':
          style = {};
          if (bool) style['V12StyleTitle'] = true;
          style['V12Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    handleEchartsTap(e) {
      // e.stopPropagation();
    },
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    async asyncLocalDatatest() {
      let refs = await this.LocalChartDataProcessing();
      let datestr = this.echartsClick;
      let LocalData = refs.data;
      let timeData = {
        staticData: LocalData[datestr],
      };
      this.handleChange(timeData);
    },
    setEchartsOptions(ParamData = null) {
      console.log(ParamData, 'sxdgsagsgsgsfgdfg');
      if (Object.keys(ParamData).length == 0 || ParamData.source.length == 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }

      let grid = {};
      let cUnit = {};
      let color = [];
      let unit = '';
      let source = [];
      let seriesList = [];
      let useYear = ''; // 年份 使用哪个维度的可以做时间，默认为x（有时需要s）
      let yearIndex = 0; // 年份以‘-’分割后取第几个
      let monthIndex = 0; // 月份 有时候是2020-01-01，或者是03-01，所以得指定分割后的下标
      let useMonth = ''; // 月份 使用哪个维度的可以做时间，默认为x（有时需要s）
      let tableDownData = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      let dropDownData = []; // 下拉 数组 数据
      let dropDownNumberData = [];
      let echartsDataStyle = 'default';
      let dropDownDataYear = ['2020', '2021'];
      let dropDownDataMonth = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        color = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (this.Configuration.propertyData.chartsUnit?.value) {
        cUnit = this.Configuration.propertyData.chartsUnit.value;
      }

      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
        dropDownDataYear = ParamData?.dropDownDataYear;
        dropDownDataMonth = ParamData?.dropDownDataMonth;
        useYear = ParamData?.useYear;
        yearIndex = ParamData?.yearIndex;
        useMonth = ParamData?.useMonth;
        monthIndex = ParamData?.monthIndex;
        tableDownData = ParamData?.tableDownData; // 日期选择需要的

        dropDownData = ParamData?.dropDownData; //ParamData里 下拉 数组 数据
        dropDownNumberData = ParamData?.dropDownNumberData;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      if (this.Configuration.propertyData?.chartsDataStyle?.value) {
        echartsDataStyle = this.Configuration.propertyData.chartsDataStyle.value;
      }
      if (this.Configuration.propertyData?.chartUnit?.value) {
        unit = this.Configuration.propertyData.chartUnit.value;
      }
      if (this.Configuration.propertyData?.chartsRightDropDown?.value) {
        this.value = this.Configuration.propertyData.chartsRightDropDown.value;
      }

      if (this.Configuration.propertyData?.chartsRightDatePicker?.value) {
        this.tvalue = this.Configuration.propertyData.chartsRightDatePicker.value;
      }

      let that = this;
      function dealSelectData() {
        let selectData = [];
        let yearData = [];
        let monthData = [];

        if (dropDownDataYear) {
          dropDownDataYear.forEach(item => {
            yearData.push({
              label: item + '年',
              value: item,
            });
          });
          selectData.push({
            flag: 'y',
            modelValue: that.getSourceYearAndMonth(source, 'year', useYear, yearIndex),
            data: yearData,
          });
        }
        if (dropDownDataMonth) {
          dropDownDataMonth.forEach(item => {
            monthData.push({
              label: item + '月',
              value: item.toString().length == 2 ? item : item.toString().padStart(2, '0'),
            });
          });
          selectData.push({
            flag: 'm',
            modelValue: that.getSourceYearAndMonth(source, 'month', useMonth, monthIndex),
            data: monthData,
          });
        }
        if (dropDownData) {
          // 遍历 dropDownData
          dropDownData.forEach(item_f => {
            let child = [];
            //
            if (item_f[3]) {
              item_f[3].forEach(item_c => {
                child.push({
                  label: item_c[0],
                  value: item_c[1],
                });
              });
            }
            if (item_f[2] != undefined && child.length == 0) {
              selectData.push({
                label: item_f[0],
                value: item_f[1],
                modelValue: item_f[2],
              });
            } else if (item_f[2] == undefined && child.length == 0) {
              selectData.push({
                label: item_f[0],
                value: item_f[1],
              });
            } else {
              selectData.push({
                label: item_f[0],
                value: item_f[1],
                modelValue: item_f[2],
                children: child,
              });
            }
          });
        }
        if (dropDownNumberData) {
          dropDownNumberData.forEach(Years => {
            let child = [];
            // 子 一月 二月... 判断
            if (Years[3]) {
              Years[3].forEach(item_D => {
                //  判断 是否有出现 展示第3个下拉框的标识
                if (item_D[2] != undefined && item_D[2] != null) {
                  child.push({
                    label: item_D[0] + '月',
                    value: item_D[1],
                    // 需要出现 日 时
                    third: item_D[2],
                  });
                } else {
                  child.push({
                    label: item_D[0] + '月',
                    value: item_D[1],
                  });
                }
              });
            }
            // 父 不为空
            if (Years[0] != undefined && child.length != 0) {
              selectData.push({
                label: Years[0],
                value: Years[1],
                modelValue: Years[2],
                children: child,
              });
            } else if (Years[0] != undefined) {
              selectData.push({
                label: Years[0],
                value: Years[1],
                modelValue: Years[2],
              });
            }
          });
        }

        that.selectData = selectData;
      }

      if (this.value.isShowRightDropDownBox) {
        dealSelectData();
      }
      function dealPickerData() {
        let tabselectData = [];
        let pickerType = [];
        if (tableDownData) {
          tableDownData.forEach(item_t => {
            if (item_t[2]) {
              tabselectData.push(
                item_t[0], //  tabMont  tabYear
                item_t[2],
              );
            } else {
              tabselectData.push(
                item_t[0], //  tabMont  tabYear
              );
            }

            pickerType.push(item_t[1]);
          });
        }
        that.tabselectData = tabselectData;
        that.pickerType = pickerType;
      }
      if (this.tvalue.isShowRightDatePicker) {
        dealPickerData();
      }

      let xAxis_data = [];
      let series = [];

      function DealData() {
        let max = 0;
        //  console.log(source,;);
        source.forEach(item => {
          if (max < parseInt(item.y)) max = item.y;
        });
        seriesList.forEach((s, index) => {
          console.log(s, index, 's, index seriesList');
          let cate = {
            name: s,
            type: 'bar',
            data: [],
            barWidth: '10%',
            itemStyle: {
              normal: {
                barBorderRadius: [30, 30, 0, 0],
                color: new Echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    { offset: 0, color: color[index] }, // 设置颜色渐变
                    { offset: 1, color: color[index].replace('1)', '0)') },
                  ],
                  false,
                ),
              },
            },
            barGap: '100%',
          };

          if (echartsDataStyle === 'default') {
            cate.label = {
              show: true,
              position: 'top',
            };
          }
          source.forEach(item => {
            xAxis_data.push(item.x);
            if (s === item.s) {
              if (echartsDataStyle === 'emphasis' && max === item.y) {
                cate.data.push({
                  value: item.y,
                  label: {
                    show: true,
                    position: 'top',
                  },
                });
              } else {
                cate.data.push(item.y);
              }
            }
          });
          series.push(cate);
        });
        xAxis_data = [...new Set(xAxis_data)];
      }
      DealData();

      this.echartsOptions = {
        backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
        textStyle: {
          color: '#fff',
          fontSize: 12,
        },
        grid: {
          ...grid,
          containLabel: true,
        },
        tooltip: {
          // trigger: 'axis',
          className: 'echarts-tooltip echarts-tooltip-dark',
          textStyle: {
            color: '#fff',
            fontSize: this.$h_Ratio(16, this.$store),
          },
        },
        legend: {
          show: false,
          // !(this.value.isShowRightDropDownBox || this.dateValue.isShowRightDatePicker),
          itemHeight: 12,
          itemWidth: 12,
          textStyle: {
            fontSize: this.$h_Ratio(12, this.$store),
          },
        },
        xAxis: {
          data: xAxis_data,
          axisLabel: {
            color: fontStyle.xAxisColor, //更改坐标轴文字颜色
            fontSize: fontStyle.xAxisSize, //更改坐标轴文字大小
          },
          axisLine: this.chartsStyles?.barStyle?.xAxis?.axisLine,
          axisTick: this.chartsStyles?.barStyle?.xAxis?.axisTick,
        },
        yAxis: {
          type: 'value',
          name: unit,
          nameTextStyle: {
            color: '#fff',
            nameLocation: 'start',
            padding: [cUnit.top, cUnit.right, cUnit.bottom, cUnit.left],
            // 单位
            fontSize: fontStyle.yAxisSize,
          },
          axisLabel: {
            color: fontStyle.yAxisColor, //更改坐标轴文字颜色
            fontSize: '12px', //更改坐标轴文字大小
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
            },
          },
        },
        series: series,
        animation: true,
      };
      // 关闭加载
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 清除定时器
      clearInterval(this.apiIntervalTaskID);
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setTimeout(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };
          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || {};
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};

          eval(filter_text);

          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 本地下拉数据切换处理
    LocalChartDataProcessing() {
      return new Promise((resolve, reject) => {
        axios
          .get('/chartsData.json')
          .then(res => {
            this.DataProcessing = res;
            let data = this.$_.cloneDeep(res);
            // console.log(data, 'LocalChartDataProcessing');
            resolve(data);
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.init(mychartDom, 'dark');
      mychart.setOption(this.echartsOptions);
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
  },
  Configuration: {
    componentTitle: '带值基础柱状图',
    componentName: 'Bar1Charts',
    componentOverViewImg: './img/charts/BarCharts/Bar1Charts.png',
    id: '',
    style: {
      width: 300,
      height: 150,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
              // 可以使用data访问api请求的响应结果
              let seriesList = []

              let seriesListKey = 'city'
              let seriesListChildrenKey = 'casts'

              data.forEach((item) => {
                seriesList.push(item[seriesListKey])
              })
              dataSet.seriesList = seriesList
              dataSet.source = []
              data.forEach((item) => {
                item[seriesListChildrenKey].forEach(item2 => {
                  dataSet.source.push({
                    s: item[seriesListKey],
                    x: item2.date,
                    y: item2.daytemp
                  })
                })
              })
           `,
            isUseInterval: true,
            apiInterval: 10,
            apiUrlMethod: 'get',
            apiPostParams: '',
            isUseUserKey: true, // 是否使用user_key
          },
          staticData: {
            seriesList: ['杭州市', '太原市', '北京市'],
            source: [
              {
                s: '杭州市',
                x: '2021-05-21',
                y: '25',
                i: 1,
              },
              {
                s: '杭州市',
                x: '2021-05-22',
                y: '26',
                i: 2,
              },
              {
                s: '杭州市',
                x: '2021-05-23',
                y: '20',
                i: 3,
              },
              {
                s: '杭州市',
                x: '2021-05-24',
                y: '27',
                i: 4,
              },

              {
                s: '太原市',
                x: '2021-05-21',
                y: '25',
                i: 1,
              },
              {
                s: '太原市',
                x: '2021-05-22',
                y: '26',
                i: 2,
              },
              {
                s: '太原市',
                x: '2021-05-23',
                y: '20',
                i: 3,
              },
              {
                s: '太原市',
                x: '2021-05-24',
                y: '27',
                i: 4,
              },

              {
                s: '北京市',
                x: '2021-05-21',
                y: '25',
                i: 1,
              },
              {
                s: '北京市',
                x: '2021-05-22',
                y: '26',
                i: 2,
              },
              {
                s: '北京市',
                x: '2021-05-23',
                y: '20',
                i: 3,
              },
              {
                s: '北京市',
                x: '2021-05-24',
                y: '27',
                i: 4,
              },
            ],
          },
        },
      },
      // 链接
      chartLink: {
        propertyComponentName: 'ChartsLinkConfiger',
        value: {
          isOpenLink: false, // 是否开启链接
          linkType: 'inner', // 链接类型 inner内链场景、outer外链地址
          linkUrl: '', // 链接url ，inner时是场景的id、outer时是http地址
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 150,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#fff',
          xAxisSize: 12,
          xAxisColor: '',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '5%',
          bottom: '5%',
          top: '12%',
        },
      },
      chartsUnit: {
        lable: '单位定位',
        propertyComponentName: 'ChartsUnitConfiger',
        value: {
          left: '10',
          right: '0',
          bottom: '0',
          top: '0',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsDataStyle: {
        propertyComponentName: 'EchartsDataStyle',
        value: 'default',
      },
      chartUnit: {
        propertyComponentName: 'MapChartUnit',
        value: '单位(张)',
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 3,
        },
      },
      chartsRightDropDown: {
        propertyComponentName: 'ChartsRightDropDownConfiger',
        value: {
          isShowRightDropDownBox: false,
        },
      },
      chartsRightDatePicker: {
        propertyComponentName: 'DatePickerSelectorConfiger',
        value: {
          isShowRightDatePicker: false,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.Bar1Charts {
  color: white;
  width: 100%;
  height: 100%;
  position: relative;
  .TableDateDownSelect {
    position: absolute;
    top: -20px;
    right: 4px;
  }
  .echarts {
    width: 100%;
    height: 100%;
  }

  .DateDropDownSelect {
    position: absolute;
    top: -12px;
    right: 4%;
    z-index: 10;
  }

  .no-data {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #ccc;
  }
}
.V11Style {
  :deep().drop-down-select .el-input__inner {
    border: 1px solid #c63a36 !important;
    color: #fff !important;
    width: 74px !important;
  }
  .DateDropDownSelect {
    right: 0 !important;
  }
  :deep().el-icon-arrow-up:before {
    color: #fff !important;
  }
}
.V12Style {
  :deep().drop-down-select:nth-child(n + 2) .el-input__inner {
    width: 50px !important;
  }
  :deep().drop-down-select .el-input__inner {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  :deep().drop-down-select {
    width: 58px !important;
  }
}

// 加载样式

:deep().el-loading-spinner {
  .path {
    stroke: var(--color) !important;
  }

  p {
    display: flex !important;
    align-items: center !important;
    color: var(--color) !important;
  }
}

.link {
  // cursor:pointer;
  :deep()canvas {
    &:hover {
      // pointer-events: auto;
      cursor: pointer;
    }
  }
}
@media screen and (min-width: 3300px) {
  .Bar1Charts .DateDropDownSelect {
    top: -30px !important;
  }
}
</style>
